import { render, staticRenderFns } from "./precarriage-filter.vue?vue&type=template&id=b0f0a996"
import script from "./precarriage-filter.vue?vue&type=script&lang=ts"
export * from "./precarriage-filter.vue?vue&type=script&lang=ts"
import style0 from "./precarriage-filter.vue?vue&type=style&index=0&id=b0f0a996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports